import React from 'react';
import { useSelector } from 'react-redux';
import {
  EVENT_ICON_MAPPING,
  STATE_ICON_MAPPING,
  EVENT_DISPLAY_NAMES,
  STATE_DISPLAY_NAMES,
} from '@components/session-timeline/utils/constants';
import { eventNamesSelector, stateNamesSelector } from '@store/timeline/data/selectors';
import { Wrapper, StyledLegend } from './styled';
import { renameAllShortInAString } from '@src/utils/common';

const TimelineEvent = () => {
  const eventNames = useSelector(eventNamesSelector);
  const stateNames = useSelector(stateNamesSelector);
  return (
    <Wrapper>
      <div className="row">
        <span>Events:</span>
        <ul className="legends">
          {eventNames.length > 0 ? (
            <>
              {eventNames.map((eventName) => (
                <li key={eventName}>
                  <StyledLegend src={EVENT_ICON_MAPPING[eventName]} />
                  <span>
                    {renameAllShortInAString(EVENT_DISPLAY_NAMES[eventName] || eventName)}
                  </span>
                </li>
              ))}
              <li key="More">
                <StyledLegend src={EVENT_ICON_MAPPING.More} />
                <span>{EVENT_DISPLAY_NAMES.More}</span>
              </li>
            </>
          ) : (
            <li>No Event</li>
          )}
        </ul>
      </div>
      <div className="row">
        <span>States:</span>
        <ul className="legends">
          {stateNames.map((stateName) => (
            <li key={stateName}>
              <StyledLegend src={STATE_ICON_MAPPING[stateName] || STATE_ICON_MAPPING.Other} />
              <span>{STATE_DISPLAY_NAMES[stateName] || stateName}</span>
            </li>
          ))}
        </ul>
      </div>
    </Wrapper>
  );
};

export default TimelineEvent;
